import { Component, OnInit } from '@angular/core';
import { Router  } from '@angular/router';
import { SharedService } from '../_service/shared.service';
import { UserService } from '../_service/user.service';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
    profileImg:string = 'assets/images/defalutpic.png';user=[];profileForm: FormGroup;submitted = false;loading:boolean=false;
    role:string='';circle:string='';passwordForm: FormGroup;psubmitted = false;ploading:boolean=false;
    selectedIndex: number = 0;
    constructor(private userapi:UserService,private router:Router,private sharedapi:SharedService,private formBuilder: FormBuilder,)
    {
        this.profileForm = this.formBuilder.group({
            'mobile' : [null, Validators.required],
            'email' : [null, Validators.required],
            'name' : [null, Validators.required]
        });

        this.passwordForm = this.formBuilder.group({
            'currentPassword' : [null, Validators.required],
            'new_password' : [null, Validators.required],
            'new_password_confirmation' : [null, Validators.required]
        });
    }

    ngOnInit(): void
    {
        // check for password update//
        if(localStorage.getItem('passwordstatus')=='0'){
            this.selectedIndex=1;
        }else{
            this.getProfile();
        }

    }

    async selectFile(event)
    {
        let file = event.target.files.item(0);
        const formData = new FormData();
        formData.append('file', file);
        await this.userapi.uploadProfilePicture(formData)
        .subscribe((data:any) => {
            this.submitted = false;
            this.loading = false;
            if(data.status)
            {
                this.sharedapi.setlogin(true);
                this.sharedapi.presentToast('Profile Updated Successful');
                localStorage.setItem('profile_pic',localStorage.getItem('s3url')+data.image);
                this.sharedapi.setProfilePic(localStorage.getItem('s3url')+data.image);
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
          }, error =>
            {
                this.sharedapi.checkError(error);
            });
    }

    getProfile()
    {
        this.userapi.getProfile().subscribe(
        (data:any) => {
            if(data && data.status)
            {
                this.profileForm.controls['name'].setValue(data.data.name);
                this.profileForm.controls['email'].setValue(data.data.email);
                this.profileForm.controls['mobile'].setValue(data.data.mobile);
                if(data.data.image && data.data.image!='null')
                this.profileImg = localStorage.getItem('s3url')+data.data.image;
                if(data.data.role==1)
                this.role = 'Admin';
                else if(data.data.role==2)
                this.role = 'BD';
                else if(data.data.role==3)
                this.role = 'City BD';
                else if(data.data.role==7)
                this.role = 'Investor';
                else if(data.data.role==8)
                this.role = 'Central OPS';
                else if(data.data.role==9)
                this.role = 'Accounts';
                this.circle = data.data.circle_name;
            }else{
              this.sharedapi.presentToast('Error Occured');
            }
        },
        error => {
            this.sharedapi.checkError(error);
        });
    }

    async updateProfile()
    {
        this.submitted = true;
        this.loading = true;
        // stop here if form is invalid
        if (this.profileForm.invalid) {
            this.loading = false;
            return;
        }

        await this.userapi.updateProfile(this.profileForm.value)
        .subscribe((data:any) => {
            this.submitted = false;
            this.loading = false;
            if(data.status)
            {
                this.sharedapi.presentToast('Profile Updated Successfully');
                localStorage.setItem('username',this.profileForm.value.name);
                this.sharedapi.setUsername(this.profileForm.value.name);
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
          }, error =>
            {
                this.sharedapi.checkError(error);
            });
    }

    get f() { return this.profileForm.controls; }
    get p() { return this.passwordForm.controls; }

    async changePassword()
    {
        this.psubmitted = true;
        this.ploading = true;
        // stop here if form is invalid
        if (this.passwordForm.invalid) {
            this.ploading = false;
            return;
        }

        await this.userapi.changePassword(this.passwordForm.value)
        .subscribe((data:any) => {
            this.psubmitted = false;
            this.ploading = false;
            if(data.status)
            {
                console.log("in function");
                localStorage.clear();
                this.router.navigate(['/login']);
                this.sharedapi.presentToast(data.msg);

                //this.passwordForm.reset();
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
          }, error =>
            {
                this.sharedapi.checkError(error);
            });
    }
}
